import { Outlet, Link, useNavigate } from "react-router-dom";
import s from "./NavBar.module.css";
import Grid from "@mui/material/Grid";
import { Header } from "../../Header";
import {
  List,
  ListItem,
  ListItemButton,
  Avatar,
  ListItemText,
  Divider,
  Collapse,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import noAutoLogo from "../../../assets/no-auto-logo.png";
import { useEffect, useState, useRef } from "react";
import LogoutIcon from "@mui/icons-material/Logout";
import { setActiveOrganization } from "../../../store/slices/gammaSlice";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import HandshakeIcon from "@mui/icons-material/Handshake";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import PaymentsIcon from "@mui/icons-material/Payments";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import SummarizeIcon from "@mui/icons-material/Summarize";
import CasinoIcon from "@mui/icons-material/Casino";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import HelpIcon from "@mui/icons-material/Help";
import InventoryRoundedIcon from "@mui/icons-material/InventoryRounded";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import StyleRoundedIcon from "@mui/icons-material/StyleRounded";
import { HeaderMobile } from "../../Header/HeaderMobile";
import userImage from "../../../assets/blank-user.jpg";
import SellIcon from "@mui/icons-material/Sell";
import { useAuth } from "../../Auth/AuthProvider";
import { useJwt, decodeToken } from "react-jwt";
import { jwtDecode } from "jwt-decode";
import { updateSession } from "src/store/slices/session";
import store from "../../../store";
import authService from "../../../services/auth.service";

export const NavBar = () => {
  const [userName, setUserName] = useState("");
  const [openNav, setOpenNav] = useState(
    window.innerWidth < 1000 ? false : true,
  );
  const [selected, setSelected] = useState({});
  const { textColor } = useSelector((state) => state.local);
  const [selectedLotery, setSelectedLotery] = useState("");
  const dispatch = useDispatch();
  // const superusuario = keycloak.realmAccess.roles.includes(roles.superusuario)
  const currentUser = useSelector((state) => state.gamma.logged_user);
  const [open, setOpen] = useState(false);
  const [reports, setReports] = useState(false);
  const { t } = useTranslation();
  let navigate = useNavigate();
  const [timeoutId, setTimeoutId] = useState(0);
  const [timeoutIdLogOut, setTimeoutIdLogOut] = useState(0);
  const ref = useRef(0);

  // session hook
  const { session } = useAuth();
  const { decodedToken } = useJwt(session.accessToken);

  // Section: Effects
  useEffect(() => {
    if (decodedToken) {
      setUserName(decodedToken.name);
    }
  }, [decodedToken]);

  const openSubMenu = () => {
    setOpen(!open);
  };

  const openReports = () => {
    setReports(!reports);
  };

  const refreshToken = async () => {
    await authService
      .refreshToken()
      .then((data) => {
        const tokenDecoded = jwtDecode(data.accessToken);
        data.decodedToken = tokenDecoded;

        store.dispatch(updateSession(data));
      })
      .catch((error) => {
        if (error instanceof Error) {
          throw error;
        } else {
          throw new Error(`Error refreshing token ${error}`);
        }
      });
  };

  useEffect(() => {
    if (ref.current === 0) {
      ref.current = 1;
    } else {
      if (timeoutId != 0) {
        clearTimeout(timeoutId);
      }
      if (timeoutIdLogOut != 0) {
        clearTimeout(timeoutIdLogOut);
      }

      setTimeoutIdLogOut(
        setTimeout(() => {
          navigate("/logout", { replace: true });
          clearTimeout(timeoutId);
          setTimeoutId(0);
          clearTimeout(timeoutIdLogOut);
          setTimeoutIdLogOut(0);
        }, session.expiresIn * 1000),
      );

      setTimeoutId(
        setTimeout(
          () => {
            Swal.fire({
              title: t("willExpireDialog"),
              icon: "warning",
              timer: 60000,
              timerProgressBar: true,
              showCancelButton: true,
              confirmButtonColor: "#d33",
              cancelButtonColor: "green",
              cancelButtonText: t("accept"),
              confirmButtonText: t("logOut"),
            }).then((result) => {
              if (result.isConfirmed) {
                clearTimeout(timeoutId);
                setTimeoutId(0);
                clearTimeout(timeoutIdLogOut);
                setTimeoutIdLogOut(0);
                navigate("/logout", { replace: true });
              }
              if (result.isDismissed) {
                if (result.dismiss !== Swal.DismissReason.timer) {
                  refreshToken().catch((error) =>
                    console.log("Refresh token error: ", error),
                  );
                }
              }
            });
          },
          (session.expiresIn - 60) * 1000,
        ),
      );
    }
  }, [session]);

  const handleChange = (e) => {
    setSelectedLotery(e.target.value);
    dispatch(setActiveOrganization(e.target.value));
  };
  const logOut = () => {
    let path = `/logout`;
    Swal.fire({
      title: t("logoutDialog"),
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#4BB544",
      cancelButtonColor: "#d33",
      cancelButtonText: t("cancel"),
      confirmButtonText: t("accept"),
    }).then((result) => {
      if (result.isConfirmed) {
        clearTimeout(timeoutId);
        setTimeoutId(0);
        clearTimeout(timeoutIdLogOut);
        setTimeoutIdLogOut(0);
        navigate(path);
      }
    });
  };

  const text = {
    fontFamily: "Roboto, sans-serif",
    fontSize: "1.7vh",
    fontWeight: "300",
  };

  const openNavMenu = () => {
    setOpenNav(!openNav);
  };

  return (
    <div className={s.container}>
      <Grid
        className={`${s.navbar} ${openNav ? s.open : null}`}
        sx={{ bgcolor: "primary.main" }}
        item
      >
        <div className={s.navContent}>
          <div className={s.navHeader}>
            <img className={s.noauto_logo} src={noAutoLogo} alt="Logo NOAUTO" />
            <div className={s.avatar}>
              <Avatar
                alt="Profile picture"
                src={userImage}
                className={s.profilepic}
              ></Avatar>
              <h3 className={s.username} style={{ color: textColor }}>
                {userName}
              </h3>
            </div>
          </div>
          <Divider />
          <nav aria-label="navigation">
            <List className={s.list}>
              <ListItem
                className={s.itemContainer}
                onClick={() => {
                  window.innerWidth < 1000 && setOpenNav(false);
                  setSelected({ raffles: true });
                }}
              >
                <Link
                  className={`${s.listItem} ${selected.raffles ? s.selectedItem : null}`}
                  to={`productos`}
                >
                  <ListItemButton className={s.itemButton}>
                    <ConfirmationNumberIcon
                      sx={{ color: "secondary.main", mr: 1, fontSize: "2.5vh" }}
                    />
                    <ListItemText
                      primary={t("products")}
                      sx={{ color: textColor }}
                      primaryTypographyProps={{ style: text }}
                      className={s.itemText}
                    />
                  </ListItemButton>
                </Link>
              </ListItem>
              {/* <ListItem
                className={s.itemContainer}
                onClick={() => {
                  window.innerWidth < 1000 && setOpenNav(false);
                  setSelected({ orders: true });
                }}
              >
                <Link
                  className={`${s.listItem} ${selected.orders ? s.selectedItem : null}`}
                  to={`ordenes-pedido`}
                >
                  <ListItemButton className={s.itemButton}>
                    <SellIcon
                      sx={{ color: "secondary.main", mr: 1, fontSize: "2.5vh" }}
                    />
                    <ListItemText
                      primary={t("purchaseOrders")}
                      sx={{ color: textColor }}
                      primaryTypographyProps={{ style: text }}
                      className={s.itemText}
                    />
                  </ListItemButton>
                </Link>
              </ListItem> */}
              <ListItem
                className={s.itemContainer}
                onClick={() => {
                  window.innerWidth < 1000 && setOpenNav(false);
                  setSelected({ deliv: true });
                }}
              >
                <Link
                  className={`${s.listItem} ${selected.deliv ? s.selectedItem : null}`}
                  to={`remitos`}
                >
                  <ListItemButton className={s.itemButton}>
                    <InventoryRoundedIcon
                      sx={{ color: "secondary.main", mr: 1, fontSize: "2.5vh" }}
                    />
                    <ListItemText
                      primary={t("deliveryNotes")}
                      sx={{ color: textColor }}
                      primaryTypographyProps={{ style: text }}
                      className={s.itemText}
                    />
                  </ListItemButton>
                </Link>
              </ListItem>
              <ListItem className={s.itemContainer}>
                <div className={s.listItem}>
                  <ListItemButton
                    onClick={openSubMenu}
                    className={s.itemButton}
                  >
                    <CloudUploadIcon
                      sx={{ color: "secondary.main", mr: 1, fontSize: "2.5vh" }}
                    />
                    <ListItemText
                      sx={{ color: textColor }}
                      primary={t("ProcessFiles")}
                      primaryTypographyProps={{ style: text }}
                      className={s.itemText}
                    />
                    {open ? (
                      <ExpandLess sx={{ color: textColor }} />
                    ) : (
                      <ExpandMore sx={{ color: textColor }} />
                    )}
                  </ListItemButton>
                </div>
              </ListItem>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div">
                  <ListItem
                    className={s.itemContainer}
                    onClick={() => {
                      window.innerWidth < 1000 && setOpenNav(false);
                      setSelected({ Pre_DistributionTelekino: true });
                    }}
                  >
                    <Link
                      className={`${s.listItem} ${selected.Pre_DistributionTelekino ? s.selectedItem : null}`}
                      to={`PreDistributionTelekino`}
                      style={{ width: "100%" }}
                    >
                      <ListItemButton className={s.itemButton} sx={{ ml: 4 }}>
                        <ListItemText
                          sx={{ color: textColor }}
                          primary={t("Pre-DistributionTelekino")}
                          primaryTypographyProps={{ style: text }}
                          className={s.itemText}
                        />
                      </ListItemButton>
                    </Link>
                  </ListItem>
                  <ListItem
                    className={s.itemContainer}
                    onClick={() => {
                      window.innerWidth < 1000 && setOpenNav(false);
                      setSelected({ telekinoSales: true });
                    }}
                  >
                    <Link
                      className={`${s.listItem} ${selected.telekinoSales ? s.selectedItem : null}`}
                      to={`VentasTelekino`}
                      style={{ width: "100%" }}
                    >
                      <ListItemButton className={s.itemButton} sx={{ ml: 4 }}>
                        <ListItemText
                          sx={{ color: textColor }}
                          primary={t("telekinoSales")}
                          primaryTypographyProps={{ style: text }}
                          className={s.itemText}
                        />
                      </ListItemButton>
                    </Link>
                  </ListItem>
                  <ListItem
                    className={s.itemContainer}
                    onClick={() => {
                      window.innerWidth < 1000 && setOpenNav(false);
                      setSelected({ salprem: true });
                    }}
                  >
                    <Link
                      className={`${s.listItem} ${selected.salprem ? s.selectedItem : null}`}
                      to={`premiados-salprem`}
                      style={{ width: "100%" }}
                    >
                      <ListItemButton className={s.itemButton} sx={{ ml: 4 }}>
                        <ListItemText
                          sx={{ color: textColor }}
                          primary={t("salprem")}
                          primaryTypographyProps={{ style: text }}
                          className={s.itemText}
                        />
                      </ListItemButton>
                    </Link>
                  </ListItem>
                  <ListItem
                    className={s.itemContainer}
                    onClick={() => {
                      window.innerWidth < 1000 && setOpenNav(false);
                      setSelected({ salvta: true });
                    }}
                  >
                    <Link
                      className={`${s.listItem} ${selected.salvta ? s.selectedItem : null}`}
                      to={`ventas-salvta`}
                      style={{ width: "100%" }}
                    >
                      <ListItemButton className={s.itemButton} sx={{ ml: 4 }}>
                        <ListItemText
                          sx={{ color: textColor }}
                          primary={t("salvtaMenu")}
                          primaryTypographyProps={{ style: text }}
                          className={s.itemText}
                        />
                      </ListItemButton>
                    </Link>
                  </ListItem>
                  <ListItem
                    className={s.itemContainer}
                    onClick={() => {
                      window.innerWidth < 1000 && setOpenNav(false);
                      setSelected({ BigPrices: true });
                    }}
                  >
                    <Link
                      className={`${s.listItem} ${selected.BigPrices ? s.selectedItem : null}`}
                      to={`PremiosMayores`}
                      style={{ width: "100%" }}
                    >
                      <ListItemButton className={s.itemButton} sx={{ ml: 4 }}>
                        <ListItemText
                          sx={{ color: textColor }}
                          primary={t("BigPrices")}
                          primaryTypographyProps={{ style: text }}
                          className={s.itemText}
                        />
                      </ListItemButton>
                    </Link>
                  </ListItem>
                  <ListItem
                    className={s.itemContainer}
                    onClick={() => {
                      window.innerWidth < 1000 && setOpenNav(false);
                      setSelected({ CuponesGanadoresTelekino: true });
                    }}
                  >
                    <Link
                      className={`${s.listItem} ${selected.CuponesGanadoresTelekino ? s.selectedItem : null}`}
                      to={`CuponesGanadoresTelekino`}
                      style={{ width: "100%" }}
                    >
                      <ListItemButton className={s.itemButton} sx={{ ml: 4 }}>
                        <ListItemText
                          sx={{ color: textColor }}
                          primary={t("winnersCouponsTelekino")}
                          primaryTypographyProps={{ style: text }}
                          className={s.itemText}
                        />
                      </ListItemButton>
                    </Link>
                  </ListItem>
                </List>
              </Collapse>
              <ListItem
                className={s.itemContainer}
                onClick={() => {
                  window.innerWidth < 1000 && setOpenNav(false);
                  setSelected({ stockcupones: true });
                }}
              >
                <Link
                  className={`${s.listItem} ${selected.stockcupones ? s.selectedItem : null}`}
                  to={`stock-de-cupones`}
                >
                  <ListItemButton className={s.itemButton}>
                    <StyleRoundedIcon
                      sx={{ color: "secondary.main", mr: 1, fontSize: "2.5vh" }}
                    />
                    <ListItemText
                      primary={t("couponsStock")}
                      sx={{ color: textColor }}
                      primaryTypographyProps={{ style: text }}
                      className={s.itemText}
                    />
                  </ListItemButton>
                </Link>
              </ListItem>
              <ListItem
                className={s.itemContainer}
                onClick={() => {
                  window.innerWidth < 1000 && setOpenNav(false);
                  setSelected({ winnercoupons: true });
                }}
              >
                <Link
                  className={`${s.listItem} ${selected.winnercoupons ? s.selectedItem : null}`}
                  to={`cupones-ganadores`}
                >
                  <ListItemButton className={s.itemButton}>
                    <EmojiEventsIcon
                      sx={{ color: "secondary.main", mr: 1, fontSize: "2.5vh" }}
                    />
                    <ListItemText
                      primary={t("winningCoupons")}
                      sx={{ color: textColor }}
                      primaryTypographyProps={{ style: text }}
                      className={s.itemText}
                    />
                  </ListItemButton>
                </Link>
              </ListItem>
              <ListItem
                className={s.itemContainer}
                onClick={() => {
                  window.innerWidth < 1000 && setOpenNav(false);
                  setSelected({ pagos: true });
                }}
              >
                <Link
                  className={`${s.listItem} ${selected.pagos ? s.selectedItem : null}`}
                  to={`pagos`}
                >
                  <ListItemButton className={s.itemButton}>
                    <PaymentsIcon
                      sx={{ color: "secondary.main", mr: 1, fontSize: "2.5vh" }}
                    />
                    <ListItemText
                      primary={t("payments")}
                      sx={{ color: textColor }}
                      primaryTypographyProps={{ style: text }}
                      className={s.itemText}
                    />
                  </ListItemButton>
                </Link>
              </ListItem>
              <ListItem className={s.itemContainer}>
                <div className={s.listItem}>
                  <ListItemButton
                    onClick={openReports}
                    className={s.itemButton}
                  >
                    <SummarizeIcon
                      sx={{ color: "secondary.main", mr: 1, fontSize: "2.5vh" }}
                    />
                    <ListItemText
                      sx={{ color: textColor }}
                      primary={t("reports")}
                      primaryTypographyProps={{ style: text }}
                      className={s.itemText}
                    />
                    {open ? (
                      <ExpandLess sx={{ color: textColor }} />
                    ) : (
                      <ExpandMore sx={{ color: textColor }} />
                    )}
                  </ListItemButton>
                </div>
              </ListItem>
              <Collapse in={reports} timeout="auto" unmountOnExit>
                <List component="div">
                  <ListItem
                    className={s.itemContainer}
                    onClick={() => {
                      window.innerWidth < 1000 && setOpenNav(false);
                      setSelected({ consultVouchers: true });
                    }}
                  >
                    <Link
                      className={`${s.listItem} ${selected.consultVouchers ? s.selectedItem : null}`}
                      to={`comprobantes`}
                      style={{ width: "100%" }}
                    >
                      <ListItemButton className={s.itemButton} sx={{ ml: 2 }}>
                        <ListItemText
                          sx={{ color: textColor }}
                          primary={t("consultVouchers")}
                          primaryTypographyProps={{ style: text }}
                          className={s.itemText}
                        />
                      </ListItemButton>
                    </Link>
                  </ListItem>
                  <ListItem
                    className={s.itemContainer}
                    onClick={() => {
                      window.innerWidth < 1000 && setOpenNav(false);
                      setSelected({ reportPrizesPaid: true });
                    }}
                  >
                    <Link
                      className={`${s.listItem} ${selected.reportPrizesPaid ? s.selectedItem : null}`}
                      to={`premios-pagados-preimpresos`}
                      style={{ width: "100%" }}
                    >
                      <ListItemButton className={s.itemButton} sx={{ ml: 2 }}>
                        <ListItemText
                          sx={{ color: textColor }}
                          primary={t("reportPrizesPaid")}
                          primaryTypographyProps={{ style: text }}
                          className={s.itemText}
                        />
                      </ListItemButton>
                    </Link>
                  </ListItem>
                  <ListItem
                    className={s.itemContainer}
                    onClick={() => {
                      window.innerWidth < 1000 && setOpenNav(false);
                      setSelected({ queryStock: true });
                    }}
                  >
                    <Link
                      className={`${s.listItem} ${selected.queryStock ? s.selectedItem : null}`}
                      to={`stock`}
                      style={{ width: "100%" }}
                    >
                      <ListItemButton className={s.itemButton} sx={{ ml: 2 }}>
                        <ListItemText
                          sx={{ color: textColor }}
                          primary={t("queryStock")}
                          primaryTypographyProps={{ style: text }}
                          className={s.itemText}
                        />
                      </ListItemButton>
                    </Link>
                  </ListItem>
                  <ListItem
                    className={s.itemContainer}
                    onClick={() => {
                      window.innerWidth < 1000 && setOpenNav(false);
                      setSelected({ controlMatrixDeliveryReturn: true });
                    }}
                  >
                    <Link
                      className={`${s.listItem} ${selected.controlMatrixDeliveryReturn ? s.selectedItem : null}`}
                      to={`matriz-control-ed`}
                      style={{ width: "100%" }}
                    >
                      <ListItemButton className={s.itemButton} sx={{ ml: 2 }}>
                        <ListItemText
                          sx={{ color: textColor }}
                          primary={t("controlMatrixDeliveryReturn")}
                          primaryTypographyProps={{ style: text }}
                          className={s.itemText}
                        />
                      </ListItemButton>
                    </Link>
                  </ListItem>
                </List>
              </Collapse>
              <ListItem
                className={s.itemContainer}
                onClick={() => {
                  window.innerWidth < 1000 && setOpenNav(false);
                  setSelected({ games: true });
                }}
              >
                <Link
                  className={`${s.listItem} ${selected.games ? s.selectedItem : null}`}
                  to={`juegos`}
                >
                  <ListItemButton className={s.itemButton}>
                    <CasinoIcon
                      sx={{ color: "secondary.main", mr: 1, fontSize: "2.5vh" }}
                    />
                    <ListItemText
                      primary={t("games")}
                      sx={{ color: textColor }}
                      primaryTypographyProps={{ style: text }}
                      className={s.itemText}
                    />
                  </ListItemButton>
                </Link>
              </ListItem>
              <ListItem
                className={s.itemContainer}
                onClick={() => {
                  window.innerWidth < 1000 && setOpenNav(false);
                  setSelected({ prov: true });
                }}
              >
                <Link
                  className={`${s.listItem} ${selected.prov ? s.selectedItem : null}`}
                  to={`proveedores`}
                >
                  <ListItemButton className={s.itemButton}>
                    <HandshakeIcon
                      sx={{ color: "secondary.main", mr: 1, fontSize: "2.5vh" }}
                    />
                    <ListItemText
                      primary={t("providers")}
                      sx={{ color: textColor }}
                      primaryTypographyProps={{ style: text }}
                      className={s.itemText}
                    />
                  </ListItemButton>
                </Link>
              </ListItem>
              <ListItem
                className={s.itemContainer}
                onClick={() => {
                  window.innerWidth < 1000 && setOpenNav(false);
                  setSelected({ ayuda: true });
                }}
              >
                <Link
                  className={`${s.listItem} ${selected.ayuda ? s.selectedItem : null}`}
                  to={`ayuda`}
                >
                  <ListItemButton className={s.itemButton}>
                    <HelpIcon
                      sx={{ color: "secondary.main", mr: 1, fontSize: "2.5vh" }}
                    />
                    <ListItemText
                      sx={{ color: textColor }}
                      primary={t("help")}
                      primaryTypographyProps={{ style: text }}
                      className={s.itemText}
                    />
                  </ListItemButton>
                </Link>
              </ListItem>
              <ListItem className={s.itemContainer}>
                <div className={s.listItem}>
                  <ListItemButton onClick={logOut} className={s.itemButton}>
                    <LogoutIcon
                      sx={{ color: "secondary.main", mr: 1, fontSize: "2.5vh" }}
                    />
                    <ListItemText
                      primary={t("logOut")}
                      sx={{ color: textColor }}
                      primaryTypographyProps={{ style: text }}
                      className={s.itemText}
                    />
                  </ListItemButton>
                </div>
              </ListItem>
            </List>
          </nav>
        </div>

        <div className={s.arrowNav}>
          <div className={s.arrowIcon} onClick={openNavMenu}>
            <ArrowBackIosNewIcon
              sx={{ fontSize: "4.5vh", color: "secondary.main" }}
            />
          </div>
        </div>
      </Grid>

      <div className={`${s.content} ${openNav ? s.openContent : null}`}>
        <div className={s.headerPos}>
          <div className={s.mobileHeader}>
            <HeaderMobile openNav={openNavMenu} />
          </div>
          <div className={s.webHeader}>
            <Header />
          </div>
        </div>
        <div className={s.outletPos}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};
